<template>
  <div class="card-img">
    <div class="card-img__header">
      <span class="card-img__title">{{ $t(`loyalty.optionSets.Card_award.${type}`) }}</span>
      <img src="@/assets/images/clients/clear-icon.svg" alt="clear" />
      <img src="@/assets/images/icon_locked.svg" alt="block" />
    </div>
    <div class="card-img__content">
      <div
        class="card-img__number"
        @click.prevent.stop="copyString(number)"
      >
        <span>{{ number }}</span>
        <Copy class="copy" />
      </div>
      <span class="card-img__status" :class="[1, 2].includes(status) ? 'card-img__status--active' : 'card-img__status--block'">{{ $t(`loyalty.optionSets.cardStatus.${status}`) }}</span>
    </div>
  </div>
</template>

<script>
import Copy from '@/manzana_library/components/Icons/Copy';
export default {
  name: "Card",

  props: {
    number: String,
    status: Number,
    type: Number,
  },

  components: {
    Copy
  },

  methods: {
    copyString(value) {
      this.$copyText(value).then(() => {
        this.$msg(this.$t('loyalty.text.8'));
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.card-img {
  background: #F5F5F5;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05), 4px 0px 10px rgba(0, 0, 0, 0.05), -4px 0px 10px rgba(0, 0, 0, 0.05), 0px -4px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  width: 230px;
  height: 140px;
  padding: 12px 12px 13px 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 20px;

  &__header {
    display: flex;
    justify-content: flex-end;
    img {
      margin-left: 10px;
    }
  }
  &__title {
    color: #000000;
    margin-right: auto;
    @include text(
        $font-family_sans_ui,
        13px,
        $font-weight_sans_ui_regular
    );
  }
  &__number {
    color: #000000;
    font-weight: 600;
    font-size: 17px;
    line-height: 23px;
    display: flex;
    align-items: center;
    .copy {
      margin-left: 8px;
      width: 10px;
      cursor: pointer;
      &:hover,
      &:active {
        path {
          fill: $color_gray;
        }
      }
      path {
        fill: #d6d6d6;
        transition: all 0.3s ease-in-out;
      }
    }
  }
  &__status {
    font-size: 13px;
    line-height: 17px;
    color: $color_green-new;
    position: relative;
    display: block;
    padding-left: 20px;
    margin-top: 7px;

    &--active {
      color: $color_green-new;

      &:before {
        position: absolute;
        content: url('#{$image-path}clients/checked-circle.svg');
        top: 1px;
        left: 0;
      }
    }

    &--block {
      color: $color_red;

      &:before {
        position: absolute;
        content: url('#{$image-path}clients/block.svg');
        top: 1px;
        left: 0;
      }
    }
  }
}
</style>
